/* My Acre header behaviour, plus the single add-to-cart toast.

   Header states, driven by scroll position and direction:
     is-top        at the very top. Promise strip showing, full height.
     (neither)     scrolled, moving up. Strip hidden, menu back in view.
     is-condensed  scrolled, moving down. Strip and main menu hidden, bar shrunk.
   The header is fixed and the section reserves its full height, so changing
   height never reflows the page under the reader.
   No requestAnimationFrame here on purpose: it does not run in a hidden tab,
   which would leave a throttle flag stuck and freeze the header. The work is
   three class toggles, and the listener is passive, so it is cheap enough.

   The cart toast lives in this file because it is global chrome, like the cart
   count, and this asset is already loaded on every page by the header section.
   See the ATC TOAST section at the bottom. */
(function(){
  var header = document.querySelector('[data-ma-header]');

  if (header) {
    var TOP = 8;    /* at or above this, treat as the top of the page */
    var ARM = 140;  /* do not hide the menu until past this */
    var DOWN = 4;   /* px of downward movement before hiding */
    var UP = 6;     /* px of upward movement before bringing it back */
    var lastY = window.pageYOffset || document.documentElement.scrollTop || 0;

    function apply(){
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;

      if (y <= TOP) {
        header.classList.add('is-top');
        header.classList.remove('is-condensed');
      } else {
        header.classList.remove('is-top');
        if (y > lastY + DOWN && y > ARM) {
          header.classList.add('is-condensed');
        } else if (y < lastY - UP) {
          header.classList.remove('is-condensed');
        }
      }

      lastY = y;
    }

    window.addEventListener('scroll', apply, {passive:true});
    window.addEventListener('resize', apply, {passive:true});
    apply();
  }

  /* Mobile drawer */
  var drawer = document.querySelector('[data-ma-drawer]');
  var scrim  = document.querySelector('.ma-h-scrim');
  var opener = document.querySelector('[data-ma-open]');
  var dbody  = document.querySelector('[data-ma-dbody]');
  var lastFocus = null;

  function openDrawer(){
    lastFocus = document.activeElement;
    document.body.classList.add('ma-drawer-open');
    if (scrim) scrim.hidden = false;
    if (opener) opener.setAttribute('aria-expanded','true');
    var close = drawer && drawer.querySelector('[data-ma-close]');
    if (close) close.focus();
  }

  function closeDrawer(){
    document.body.classList.remove('ma-drawer-open');
    if (opener) opener.setAttribute('aria-expanded','false');
    window.setTimeout(function(){ if (scrim) scrim.hidden = true; }, 220);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  if (opener) opener.addEventListener('click', openDrawer);

  Array.prototype.forEach.call(document.querySelectorAll('[data-ma-close]'), function(el){
    el.addEventListener('click', closeDrawer);
  });

  document.addEventListener('keydown', function(e){
    if (!document.body.classList.contains('ma-drawer-open')) return;
    if (e.key === 'Escape') { closeDrawer(); return; }
    /* 11 Sep 2026 (Claude): keep Tab inside the open menu (it escaped to the page behind). */
    if (e.key !== 'Tab' || !drawer) return;
    var f = Array.prototype.filter.call(drawer.querySelectorAll('a[href],button:not([disabled]),input:not([type=hidden]):not([disabled]),select:not([disabled]),[tabindex]:not([tabindex="-1"])'), function(el){ return el.offsetWidth || el.offsetHeight || el.getClientRects().length; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1], a = document.activeElement;
    if (!drawer.contains(a)) { e.preventDefault(); first.focus(); }
    else if (e.shiftKey && a === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && a === last) { e.preventDefault(); first.focus(); }
  });

  /* 20 Oct 2026 (Claude): drawer sub-screens replace the accordions. Tapping a family slides its
     screen in from the right; "All" slides back. Tabs switch By type and By brand. */
  var dbodyEl = document.querySelector('[data-ma-dbody]');
  function closeSubs(){
    Array.prototype.forEach.call(document.querySelectorAll('[data-ma-subpanel].is-active'), function(p){ p.classList.remove('is-active'); });
    if (dbodyEl) dbodyEl.classList.remove('is-sub');
  }
  Array.prototype.forEach.call(document.querySelectorAll('[data-ma-sub]'), function(btn){
    btn.addEventListener('click', function(){
      var p = document.getElementById(btn.getAttribute('data-ma-sub'));
      if (!p) return;
      closeSubs();
      p.scrollTop = 0;
      p.classList.add('is-active');
      if (dbodyEl) dbodyEl.classList.add('is-sub');
      var back = p.querySelector('[data-ma-back]');
      if (back) window.setTimeout(function(){ back.focus(); }, 260);
    });
  });
  Array.prototype.forEach.call(document.querySelectorAll('[data-ma-back]'), function(btn){
    btn.addEventListener('click', closeSubs);
  });
  Array.prototype.forEach.call(document.querySelectorAll('[data-ma-subpanel]'), function(p){
    var tabs = p.querySelectorAll('[data-ma-tab]');
    Array.prototype.forEach.call(tabs, function(tab){
      tab.addEventListener('click', function(){
        var want = tab.getAttribute('data-ma-tab');
        Array.prototype.forEach.call(tabs, function(t){ var on = t === tab; t.classList.toggle('is-on', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); });
        Array.prototype.forEach.call(p.querySelectorAll('[data-ma-tabpanel]'), function(pl){ pl.hidden = pl.getAttribute('data-ma-tabpanel') !== want; });
      });
    });
  });
  document.addEventListener('click', function(e){
    if (e.target.closest && e.target.closest('[data-ma-close]')) window.setTimeout(closeSubs, 260);
  });

  /* Desktop panels open on hover through CSS. A click toggles them too, for touch laptops and
     iPads, and Escape or a click elsewhere closes them. */
  var tops = Array.prototype.slice.call(document.querySelectorAll('[data-ma-top]'));
  function closeTops(except){
    tops.forEach(function(b){ if (b !== except) { b.setAttribute('aria-expanded','false'); b.parentNode.classList.remove('is-open'); } });
  }
  tops.forEach(function(btn){
    btn.addEventListener('click', function(e){
      e.stopPropagation();
      var li = btn.parentNode, open = !li.classList.contains('is-open');
      closeTops(btn);
      li.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    var li = btn.parentNode;
    /* 21 Oct 2026 (Hayden): the open panel must follow the pointer. Pointing at another item closes
       any panel opened by a click and drops the click focus, so only one item is ever lit. */
    li.addEventListener('mouseenter', function(){
      closeTops(btn);
      if (document.activeElement && document.activeElement !== btn && document.activeElement.closest && document.activeElement.closest('.ma-h-nav')) document.activeElement.blur();
      if (navEl) navEl.classList.add('is-hovering');
    });
    li.addEventListener('mouseleave', function(){ li.classList.remove('is-open'); btn.setAttribute('aria-expanded','false'); });
    /* Keyboard: Tab onto an item opens its panel; Tab out of it closes it. */
    btn.addEventListener('keyup', function(e){ if (e.key === 'Tab') { closeTops(btn); li.classList.add('is-open'); btn.setAttribute('aria-expanded','true'); } });
    li.addEventListener('focusout', function(e){ if (!li.contains(e.relatedTarget)) { li.classList.remove('is-open'); btn.setAttribute('aria-expanded','false'); } });
  });
  var navEl = document.querySelector('.ma-h-nav');
  if (navEl) navEl.addEventListener('mouseleave', function(){ navEl.classList.remove('is-hovering'); });
  document.addEventListener('click', function(e){
    if (!e.target.closest || !e.target.closest('.ma-h-nav')) closeTops(null);
  });
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape') { closeTops(null); closeSearch(); }
  });

  /* Search sits behind the icon. The phone gets the shorter placeholder. */
  var sbtn = document.querySelector('[data-ma-search]');
  var sbar = document.querySelector('[data-ma-sbar]');
  function closeSearch(){
    if (!sbar || sbar.hidden) return;
    sbar.hidden = true;
    if (sbtn) sbtn.setAttribute('aria-expanded','false');
  }
  if (sbtn && sbar) {
    var sin = sbar.querySelector('input[type="search"]');
    if (sin && window.matchMedia('(max-width:1023px)').matches && sin.getAttribute('data-ph-m')) sin.placeholder = sin.getAttribute('data-ph-m');
    sbtn.addEventListener('click', function(e){
      e.stopPropagation();
      var open = sbar.hidden;
      closeTops(null);
      sbar.hidden = !open;
      sbtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open && sin) sin.focus();
    });
    document.addEventListener('click', function(e){
      if (!sbar.hidden && !sbar.contains(e.target) && e.target !== sbtn) closeSearch();
    });
  }

  /* ------------------------------------------------------------------
     ATC TOAST
     One popup for every add to cart. Previously there were three
     behaviours: the main button showed nothing (its notification was
     killed by an inline display:none), the accessory modal showed the
     vendor theme's banner sliding up from the bottom, and Complete your
     setup redirected to /cart. This intercepts the add request itself,
     so every path behaves the same, including any added later.

     Note on geometry: ma-pdp.css pins this element to bottom:5.25rem
     under 600px. Every rule below therefore sets top AND bottom, or the
     card stretches the full height of the screen.
     ------------------------------------------------------------------ */
  var TOAST_MS = 6000;
  var hideTimer = null;

  function injectStyles(){
    if (document.getElementById('ma-atc-style')) return;
    var css = ''
      + 'html body .atc-banner--container{display:none !important}'
      + 'html body .ma-cart-notification{position:fixed;top:190px;bottom:auto;left:auto;right:clamp(12px,2.4vw,44px);z-index:10000;'
      + 'width:min(92vw,340px);background:#fff;border:1px solid #E5E7EB;border-radius:10px;'
      + 'box-shadow:0 1px 2px rgba(18,20,23,.04),0 10px 28px rgba(18,20,23,.14);padding:16px 18px;'
      + "font-family:'Inter',-apple-system,BlinkMacSystemFont,'Segoe UI',Helvetica,Arial,sans-serif;"
      + 'opacity:0;transform:translateY(-6px);transition:opacity .18s ease,transform .18s ease;display:none !important}'
      + 'html body .ma-cart-notification.is-visible{display:block !important;opacity:1;transform:none}'
      + "html body .ma-cart-notification__title{font-family:'Lora',Georgia,serif;font-size:15px;font-weight:600;color:#121417;margin:0 0 4px}"
      + 'html body .ma-cart-notification__product{font-size:13px;line-height:1.45;color:#4F525A;margin:0 0 14px}'
      + 'html body .ma-cart-notification__actions{display:flex;gap:10px;align-items:center}'
      + 'html body .ma-cart-notification__primary{display:inline-flex;align-items:center;justify-content:center;'
      + 'background:#8A5A34;color:#fff !important;font-size:13px;font-weight:600;padding:10px 16px;border-radius:10px;text-decoration:none;border:1.5px solid #8A5A34}'
      + 'html body .ma-cart-notification__primary:hover{background:#6E4826;border-color:#6E4826;color:#fff !important}'
      + 'html body .ma-cart-notification__secondary{background:#fff;color:#8A5A34 !important;font-family:inherit;font-size:13px;font-weight:600;'
      + 'padding:10px 16px;border-radius:10px;border:1.5px solid #8A5A34;cursor:pointer}'
      + 'html body .ma-cart-notification__secondary:hover{background:rgba(138,90,52,.06)}'
      + '@media (max-width:960px){html body .ma-cart-notification{top:174px;bottom:auto;left:clamp(12px,2.4vw,44px);right:clamp(12px,2.4vw,44px);width:auto}}'
      + '@media (prefers-reduced-motion:reduce){html body .ma-cart-notification{transition:none}}';
    var s = document.createElement('style');
    s.id = 'ma-atc-style';
    s.textContent = css;
    document.head.appendChild(s);
  }

  function getToast(){
    var el = document.querySelector('[data-ma-cart-notification]');
    if (el) return el;
    el = document.createElement('div');
    el.className = 'ma-cart-notification';
    el.setAttribute('data-ma-cart-notification','');
    el.setAttribute('aria-live','polite');
    el.innerHTML = '<p class="ma-cart-notification__title">Added to cart</p>'
      + '<p class="ma-cart-notification__product" data-ma-cart-notification-product></p>'
      + '<div class="ma-cart-notification__actions">'
      + '<a href="/cart" class="ma-cart-notification__primary">View cart</a>'
      + '<button type="button" class="ma-cart-notification__secondary" data-ma-cart-notification-dismiss>Keep browsing</button>'
      + '</div>';
    document.body.appendChild(el);
    return el;
  }

  function hideToast(){
    var el = document.querySelector('[data-ma-cart-notification]');
    if (el) el.classList.remove('is-visible');
  }

  function showToast(label){
    injectStyles();
    var el = getToast();
    var p = el.querySelector('[data-ma-cart-notification-product]');
    if (p && label) p.textContent = label;
    el.classList.add('is-visible');

    var dismiss = el.querySelector('[data-ma-cart-notification-dismiss]');
    if (dismiss && !dismiss.getAttribute('data-ma-bound')) {
      dismiss.setAttribute('data-ma-bound','1');
      dismiss.addEventListener('click', hideToast);
    }

    window.clearTimeout(hideTimer);
    hideTimer = window.setTimeout(hideToast, TOAST_MS);
    refreshCount();
  }

  /* 21 Oct 2026 (Claude): the pip could lag after an add-on tick on a slow connection. Reads now skip the
     browser cache, a late reply can never overwrite a newer one, and every change is read twice, once
     straight away and once 900ms later. */
  var countSeq = 0;
  function readCount(){
    var mine = ++countSeq;
    window.fetch('/cart.js', {headers:{'Accept':'application/json'}, cache:'no-store'})
      .then(function(r){ return r.json(); })
      .then(function(c){
        if (mine !== countSeq) return;
        Array.prototype.forEach.call(document.querySelectorAll('[data-header-cart-count]'), function(el){
          el.textContent = c.item_count;
          el.setAttribute('data-header-cart-count', c.item_count);
          el.classList.toggle('is-on', c.item_count > 0);
        });
      })
      .catch(function(){});
  }
  var countTimer = null;
  function refreshCount(){
    readCount();
    window.clearTimeout(countTimer);
    countTimer = window.setTimeout(readCount, 900);
  }

  /* 11 Sep 2026 (Claude): /cart's stepper and Remove, and the "Commonly bought with" buttons, update
     the count by dispatching cart:refresh but never touched this pip, so the badge went stale. */
  document.addEventListener('cart:refresh', refreshCount);

  function labelFrom(data){
    if (!data) return '';
    if (data.product_title) return data.product_title;
    if (data.items && data.items.length) {
      if (data.items.length === 1) return data.items[0].product_title || '';
      return data.items.length + ' items added';
    }
    return '';
  }

  function isAddUrl(url){
    return typeof url === 'string' && /\/cart\/add(\.js)?(\?|$)/.test(url.split('#')[0]);
  }
  function isCartEditUrl(url){
    return typeof url === 'string' && /\/cart\/(change|update|clear)(\.js)?(\?|$)/.test(url.split('#')[0]);
  }

  /* fetch */
  if (window.fetch) {
    var origFetch = window.fetch;
    window.fetch = function(input, init){
      var url = (typeof input === 'string') ? input : (input && input.url) || '';
      var watch = isAddUrl(url);
      var edit = isCartEditUrl(url);
      var promise = origFetch.apply(this, arguments);
      if (edit) promise.then(function(res){ if (res && res.ok) refreshCount(); }).catch(function(){});
      if (watch) {
        promise.then(function(res){
          if (!res || !res.ok) return;
          res.clone().json().then(function(d){ showToast(labelFrom(d)); }).catch(function(){ showToast(''); });
        }).catch(function(){});
      }
      return promise;
    };
  }

  /* XMLHttpRequest, which the vendor theme's own form still uses */
  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(method, url){
    this.__maWatch = isAddUrl(url);
    this.__maEdit = isCartEditUrl(url);
    return origOpen.apply(this, arguments);
  };
  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function(){
    var xhr = this;
    if (xhr.__maEdit) {
      xhr.addEventListener('load', function(){ if (xhr.status >= 200 && xhr.status < 300) refreshCount(); });
    }
    if (xhr.__maWatch) {
      xhr.addEventListener('load', function(){
        if (xhr.status < 200 || xhr.status >= 300) return;
        var d = null;
        try { d = JSON.parse(xhr.responseText); } catch(e) {}
        showToast(labelFrom(d));
      });
    }
    return origSend.apply(this, arguments);
  };
})();

/* MENU IMAGES LOAD ON INTENT (11 Sep 2026)
   The mega menu prints product cards on every page. With a live src, Google counted those photos as part
   of whatever page it was reading and picked one for the search thumbnail: a greenhouse appeared beside the
   Aquascape pondless kit. The cards now carry the real URL in data-ma-hsrc and a 1px placeholder in src.
   The first sign a visitor is heading for the menu (pointer over the nav, keyboard focus, a tap, or the
   mobile drawer opening) swaps every card in, so the images are ready by the time a panel shows. Nothing
   here runs on a timer or on scroll, because Googlebot runs those; it never hovers. */
(function(){
  var done = false;
  function loadMenuImages(){
    if (done) return; done = true;
    Array.prototype.forEach.call(document.querySelectorAll('img[data-ma-hsrc]'), function(im){
      im.src = im.getAttribute('data-ma-hsrc');
      im.removeAttribute('data-ma-hsrc');
    });
  }
  var nav = document.querySelector('.ma-h-nav');
  if (nav) {
    nav.addEventListener('mouseover', loadMenuImages, {passive:true});
    nav.addEventListener('focusin', loadMenuImages);
    nav.addEventListener('touchstart', loadMenuImages, {passive:true});
  }
  var opener = document.querySelector('[data-ma-open]');
  if (opener) opener.addEventListener('click', loadMenuImages);
})();
